import {getAxiosInstance, requestConfig} from "../../http-common";
import { CreateMigrationRule } from "../../models/migrationrules/CreateMigrationRule";
import { UpdateMigrationRule } from "../../models/migrationrules/UpdateMigrationRule";

const RESOURCE_NAME = "master";
const RESULTS_RESOURCE_NAME = "results";
const RESULTS_RESOURCE_DETAILS_NAME = "results/details";

const getAll = (tableId: number) => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}?tableId=${tableId}`, requestConfig());
};

const getAllResults = (groupCode: string, tableId: number) => {
  const http = getAxiosInstance();
  return http.get(
    `${RESULTS_RESOURCE_NAME}?groupCode=${groupCode}&tableId=${tableId}`,
    requestConfig()
  );
};

const getAllDetails = (code: string, groupCode: string, tableId: number) => {
  const http = getAxiosInstance();
  return http.get(
    `${RESULTS_RESOURCE_DETAILS_NAME}?code=${code}&groupCode=${groupCode}&tableId=${tableId}`,
    requestConfig()
  );
};

const create = (model: CreateMigrationRule) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}`, model, requestConfig());
};

const update = (model: UpdateMigrationRule) => {
  const http = getAxiosInstance();
  return http.put(`${RESOURCE_NAME}/${model.masterId}`, model, requestConfig());
};

const remove = (id: number) => {
  const http = getAxiosInstance();
  return http.delete(`${RESOURCE_NAME}/${id}`, requestConfig());
};

const MigrationRuleService = {
  getAll,
  getAllResults,
  getAllDetails,
  create,
  update,
  remove,
};
export default MigrationRuleService;
